import { Component, OnInit, Input } from '@angular/core';
import { Search, ParamsService, ListService } from 'elbuild-ui-lib-core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-consultantresource-list-filters',
	templateUrl: './consultantresource-list-filters.component.html',
	styleUrls: ['./consultantresource-list-filters.component.scss']
})
export class ConsultantresourceListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;

	daylyhrs = { from: undefined, to: undefined, min: 0, max: 12 };
	basehourlysalary = { from: undefined, to: undefined, min: 0, max: 1000 };

	@Input()
	consultantid: number;

	constructor(
		router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
		private listService: ListService
	) {
		super(router, _route, paramsService);

	}

	ngOnInit() { }

	readQueryParams(params: string) {
		super.readQueryParams(params);

	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		this.daylyhrs.from = undefined;
		this.daylyhrs.to = undefined;
		this.basehourlysalary.from = undefined;
		this.basehourlysalary.to = undefined;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setDaylyhrs();
		this.setBasehourlysalary();
		super.search(keeppage);
	}

	setDaylyhrs(): void {
		if ((this.daylyhrs.to || this.daylyhrs.to === 0) && !this.daylyhrs.from) this.daylyhrs.from = this.daylyhrs.min;
		if ((this.daylyhrs.from || this.daylyhrs.from === 0) && !this.daylyhrs.to) this.daylyhrs.to = this.daylyhrs.max;

		if (this.daylyhrs.from && this.daylyhrs.from < this.daylyhrs.min) this.daylyhrs.from = this.daylyhrs.min;
		if (this.daylyhrs.to && this.daylyhrs.to < this.daylyhrs.min) this.daylyhrs.to = this.daylyhrs.min;
		if (this.daylyhrs.from && this.daylyhrs.from > this.daylyhrs.max) this.daylyhrs.from = this.daylyhrs.max;
		if (this.daylyhrs.to && this.daylyhrs.to > this.daylyhrs.max) this.daylyhrs.to = this.daylyhrs.max;

		this.searchparams.rangeTmp['daylyhrs'] = { start: this.daylyhrs.from, stop: this.daylyhrs.to };
	}

	setBasehourlysalary(): void {
		if ((this.basehourlysalary.to || this.basehourlysalary.to === 0) && !this.basehourlysalary.from)
			this.basehourlysalary.from = this.basehourlysalary.min;
		if ((this.basehourlysalary.from || this.basehourlysalary.from === 0) && !this.basehourlysalary.to)
			this.basehourlysalary.to = this.basehourlysalary.max;

		if (this.basehourlysalary.from && this.basehourlysalary.from < this.basehourlysalary.min)
			this.basehourlysalary.from = this.basehourlysalary.min;
		if (this.basehourlysalary.to && this.basehourlysalary.to < this.basehourlysalary.min)
			this.basehourlysalary.to = this.basehourlysalary.min;
		if (this.basehourlysalary.from && this.basehourlysalary.from > this.basehourlysalary.max)
			this.basehourlysalary.from = this.basehourlysalary.max;
		if (this.basehourlysalary.to && this.basehourlysalary.to > this.basehourlysalary.max)
			this.basehourlysalary.to = this.basehourlysalary.max;

		this.searchparams.rangeTmp['basehourlysalary'] = { start: this.basehourlysalary.from, stop: this.basehourlysalary.to };
	}

}
